<div
  class="severity-label"
  [ngClass]="{
    small: smallSize,
    greyOut:
      supportedSeverity === supportedSeverityLabels.coming_soon ||
      supportedSeverity === supportedSeverityLabels.insufficient_data,
    healthy: supportedSeverity === supportedSeverityLabels.healthy,
    informational: supportedSeverity === supportedSeverityLabels.informational,
    low: supportedSeverity === supportedSeverityLabels.low,
    medium: supportedSeverity === supportedSeverityLabels.medium,
    high: supportedSeverity === supportedSeverityLabels.high,
    critical: supportedSeverity === supportedSeverityLabels.critical,
  }"
>
  {{ supportedSeverity | beautifyDisplayString }}
</div>
